export default () => {
    const header = document.querySelector('.header');
    const menu = document.querySelector('.page-menu__container');

    const handleResize = () => {
        if (header) {
            document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
        }
        if (menu) {
            document.documentElement.style.setProperty('--page-menu-height', menu.offsetHeight + 'px');
        }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
};
